/**
 */

// The second-level activities in the application? I gotta think of a proper
// name for this.
export enum ContentSection {
  Pages = 1,      // Starting from 1 so that if (contentSection) works.
  Devices,
  Events,
  ContentLibrary,
  DataLogging,
  Settings
};

export class NavigationEvent extends Event {
  static eventType = 'rebuild-navigate';

  activity: ContentSection;

  constructor(activity: ContentSection) {
    super(NavigationEvent.eventType, {
        bubbles: true,
        composed: true,
    });

    this.activity = activity;
  }
}
